import { Observable, of } from 'rxjs';
import * as _ from 'lodash';
import { GeneratorManager } from '../../../generator';
import { IDataSourceConfig } from '../../../interface/file';
import { DataSourceConfig } from './data.source.config';
import { DataSourceConfigSet } from './data.source.config.set';


/**
 * 每个页面都有自己的DataSourceManager
 * 如此便于在页面被销毁时，释放该页面的全部数据源
 *
 * 1、是否可以切换DataSourceConfigSet
 */
export class DataSourceManager {
  private _dataSourceMap: Map<string, Observable<any>> = new Map();
  private _generatorManager: GeneratorManager = GeneratorManager.getInstance();

  constructor(private _dataSourceConfigSet: DataSourceConfigSet) {

  }

  load(configArray: Array<IDataSourceConfig>) {

  }

  /**
   * 获取依赖的生成器仓库keys
   * @param arrayOfID
   */
  getDependencies(arrayOfID: Array<string>): Array<string> {
    let ret;
    ret = arrayOfID.map(id => {
      return this._dataSourceConfigSet.has(id) ? this._dataSourceConfigSet.getDataSourceConfig(id).repositoryID : null;
    });
    return _.uniq(_.compact(ret));
  }

  /**
   * 根据DataSourceConfig id获取dataSource
   * @param id
   */
  getDataSource(id: string): Observable<any> {
    const map = this._dataSourceMap;
    if (map.has(id)) {
      return map.get(id);
    } else if (this._dataSourceConfigSet.has(id)) {
      const dataSource = this._getDataSource(this._dataSourceConfigSet.getDataSourceConfig(id));
      map.set(id, dataSource);
      return dataSource;
    } else {
      return of('blank');
    }
  }

  /**
   * input：DataSourceConfig
   * output：DataSource（Observable） 可被缓存
   * @param dataSourceConfig 数据源配置信息
   * @private
   */
  private _getDataSource(dataSourceConfig: DataSourceConfig): Observable<any> {
    if (dataSourceConfig) {
      const {generatorPath, generatorParams} = dataSourceConfig;
      if (this._generatorManager.has(generatorPath)) {
        return this._generatorManager
          .getGenerator(generatorPath)
          .generate(generatorParams);
      }
    }
  }

  getDataSourceConfigArray(ids: Array<string>): Array<IDataSourceConfig> {
    return ids
      .map(value => this._dataSourceConfigSet.getDataSourceConfig(value))
      .filter(value => !!value)
      .map(value => value.value);
  }


  clear() {

  }

  /**
   * unsubscribe对所有数据源的监听
   */
  destroy() {
    this._dataSourceConfigSet.destroy();
    this._dataSourceConfigSet = null;

    this._dataSourceMap.clear();
    this._dataSourceMap = null;
  }
}
